import { compose, withHandlers, withState } from 'recompose';
import Schedules from './schedules';

export const withScheduleTabs = compose(
  withState('activeTab', 'setActiveTab', 'current'),
  withHandlers({
    setTabTo: ({ setActiveTab }) => tab => (e) => {
      e.preventDefault();

      setActiveTab(tab);
    },
  }),
);

export default withScheduleTabs(Schedules);
